<h1 class="title-section">{{ community.displayName }}</h1>
<mat-card class="about-section">
  <mat-card-header>
    <mat-card-title>About</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div>
      <span class="section-header">Description</span>
      <p class="description">{{ community.description }}</p>
    </div>

    <div>
      <span class="section-header">Managers</span>

      @for (manager of managers(); track manager) {
        <div class="member">
          <p class="member-name">{{ manager.firstName }} {{ manager.lastName }}</p>
        </div>
      }
    </div>

  </mat-card-content>
</mat-card>
<mat-card class="file-section">
  <mat-card-header>
    <mat-card-title> Documents &#8226; {{ community.files.length }}</mat-card-title>

    <button mat-icon-button (click)="openFileUploadModal()">
      <mat-icon>upload_file</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content>
    @for (file of community.files; track file) {
      <div>
        <a href="api/community/{{community.id}}/download/{{file.fileName}}"
        [download]="file.fileName"> {{ file.displayName }}</a>
      </div>
    }
  </mat-card-content>
</mat-card>
<mat-card class="member-section">
  <mat-card-header>
    <mat-card-title> Members &#8226; {{ community.members.length }}</mat-card-title>

    <!--   Leaving this here to remember to add an add user ability when we get a user base -->
    <!--    <button mat-icon-button *ngIf="isManager" (click)="addMember()">-->
    <!--      <mat-icon>person_add</mat-icon>-->
  <!--    </button>-->
</mat-card-header>
<mat-card-content>
  @for (member of community.members; track member) {
    <div class="member">
      <span class="member-name">{{ member.firstName }} {{ member.lastName }}</span>
      @if (isManager) {
        <button mat-icon-button
          [matMenuTriggerFor]="memberActionMenu"
          [matMenuTriggerData]="{member: member}">
          <mat-icon>more_vert</mat-icon>
        </button>
      }
    </div>
  }
</mat-card-content>
</mat-card>


<mat-menu #memberActionMenu="matMenu">
  <ng-template matMenuContent let-member="member">
    <button mat-menu-item (click)="promoteToManager(member)">
      <mat-icon>group</mat-icon>
      <span>Promote to manager</span>
    </button>
    <button mat-menu-item (click)="removeFromCommunity(member)">
      <mat-icon>delete</mat-icon>
      <span>Remove</span>
    </button>
  </ng-template>
</mat-menu>
